var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1374_115067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.2426 37.3631V37.6323L41.433 37.8227L46.5826 42.9724L46.5826 42.9724C47.5069 43.8965 47.5069 45.3949 46.5826 46.3192C46.1204 46.7814 45.5159 47.0124 44.9092 47.0124C44.3025 47.0124 43.698 46.7814 43.2358 46.3192L37.2026 40.286L37.2025 40.2859C36.7587 39.8423 36.5094 39.2402 36.5094 38.6126V26.5461C36.5094 25.2391 37.5689 24.1795 38.876 24.1795C40.1831 24.1795 41.2426 25.2391 41.2426 26.5461V37.3631Z",
    fill: "#FDC20C",
    stroke: "#163E33",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4926 14.4797C41.4926 15.9249 40.3211 17.0963 38.876 17.0963C37.4309 17.0963 36.2594 15.9249 36.2594 14.4797C36.2594 13.0346 37.4309 11.8631 38.876 11.8631C40.3211 11.8631 41.4926 13.0346 41.4926 14.4797Z",
    fill: "#FDC20C",
    stroke: "#163E33",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4926 62.1421C41.4926 63.5872 40.3211 64.7587 38.876 64.7587C37.4309 64.7587 36.2594 63.5872 36.2594 62.1421C36.2594 60.697 37.4309 59.5255 38.876 59.5255C40.3211 59.5255 41.4926 60.697 41.4926 62.1421Z",
    fill: "#FDC20C",
    stroke: "#163E33",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9633 38.6126C17.9633 40.0577 16.7918 41.2292 15.3467 41.2292C13.9016 41.2292 12.7301 40.0577 12.7301 38.6126C12.7301 37.1674 13.9016 35.9959 15.3467 35.9959C16.7918 35.9959 17.9633 37.1674 17.9633 38.6126Z",
    fill: "#FDC20C",
    stroke: "#163E33",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0229 38.6126C65.0229 40.0577 63.8514 41.2292 62.4063 41.2292C60.9611 41.2292 59.7896 40.0577 59.7896 38.6126C59.7896 37.1674 60.9611 35.9959 62.4063 35.9959C63.8514 35.9959 65.0229 37.1674 65.0229 38.6126Z",
    fill: "#FDC20C",
    stroke: "#163E33",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8189 69.6745L50.819 69.6745C52.0417 69.2128 53.4071 69.8301 53.8686 71.0531C54.3301 72.2759 53.7129 73.6413 52.4901 74.1028C48.1432 75.7432 43.5634 76.5751 38.8762 76.5751C17.5834 76.5751 0.913672 59.9054 0.913672 38.6126C0.913672 17.3197 17.5834 0.65 38.8762 0.65C60.1691 0.65 76.8388 17.3197 76.8388 38.6126C76.8388 48.2128 73.2882 57.3571 66.9549 64.3956L65.9788 65.4803H67.4381H71.6915C72.9986 65.4803 74.0581 66.5398 74.0581 67.8469C74.0581 69.154 72.9986 70.2135 71.6915 70.2135H65.6583C61.0502 70.2135 57.2584 66.4582 57.2584 61.8137V55.7805C57.2584 54.4734 58.318 53.4139 59.625 53.4139C60.9321 53.4139 61.9916 54.4734 61.9916 55.7805V61.1315V62.7917L63.1189 61.5728C68.871 55.3531 72.1056 47.1901 72.1056 38.6126C72.1056 19.9847 57.5041 5.38321 38.8762 5.38321C20.2484 5.38321 5.64688 19.9847 5.64688 38.6126C5.64688 57.2404 20.2484 71.8419 38.8762 71.8419C42.9885 71.8419 47.0072 71.1128 50.8189 69.6745Z",
    fill: "white",
    stroke: "#163E33",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1374_115067"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.2251,
    height: 77.2251,
    fill: "white",
    transform: "translate(0.263672)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.becaa34a418e80702f99c13ae04c76bd.svg";
export { ForwardRef as ReactComponent };